// The postcode in use and the nearby branches pinned for it, read from the
// tab session (DEV-51045). The location screens use it to open the branch
// card on what's already pinned, so confirming without touching anything
// changes nothing.

import { useMemo, useSyncExternalStore } from 'react'

import {
  parseEngineerSession,
  readEngineerSessionRaw,
  subscribeToEngineerSession,
} from '../services/engineerSession'
import type { CurrentAtBranches } from '../services/engineerSession'

/** Null before any postcode has been set in this tab. */
export function useCurrentAtBranches(): CurrentAtBranches | null {
  const rawSession = useSyncExternalStore(
    subscribeToEngineerSession,
    readEngineerSessionRaw,
    () => null,
  )
  return useMemo(() => {
    const session = parseEngineerSession(rawSession)
    if (!session) return null
    return {
      postcode: session.postcode,
      branchIds: session.atBranches.map((branch) => branch.branchId),
      branches: session.atBranches,
    }
  }, [rawSession])
}
